import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { api, setRole, hasSession } from '../utils/api';
import { useI18n } from '../i18n/I18nProvider';
import AuthIllustration from '../components/AuthIllustration';
import BrandMark from '../components/BrandMark';

const RegisterPage = () => {
  const [name, setName]         = useState('');
  const [email, setEmail]       = useState('');
  const [password, setPassword] = useState('');
  const [error, setError]       = useState('');
  const [loading, setLoading]   = useState(false);
  const navigate = useNavigate();
  const { t } = useI18n();

  useEffect(() => {
    if (hasSession()) navigate('/dashboard', { replace: true });
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await api.register(name, email, password);
      if (res.ok) {
        // Auto-login after registration
        const loginRes = await api.login(email, password);
        if (loginRes.ok) {
          // The session arrives as an httpOnly cookie (PIN-320).
          const data = await loginRes.json();
          setRole(data.role);
          navigate('/dashboard', { replace: true });
        } else {
          navigate('/login', { replace: true });
        }
      } else {
        const data = await res.json().catch(() => ({}));
        // Map known backend codes to localized text; never show the raw English
        // string (PIN-252).
        setError(data.error === 'email_taken' ? t('auth.emailTaken') : t('auth.registrationFailed'));
      }
    } catch {
      setError(t('auth.connectionError'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="uh-login-container">
      <div className="uh-login-card">
        <div className="uh-login-illustration">
          <AuthIllustration />
        </div>
        <div className="uh-login-form">
          <div className="uh-login-header">
            <div className="uh-login-greeting">{t('auth.getStarted')}</div>
            <div className="uh-login-subtitle"><BrandMark size={28} />{t('app.brand')}</div>
          </div>
          <div className="uh-login-form-container">
            <div className="uh-login-form-title">{t('auth.createAccount')}</div>
            {error && <div className="uh-alert-error">{error}</div>}
            <form onSubmit={handleSubmit}>
              <div className="uh-login-field">
                <label htmlFor="name" className="uh-login-label">{t('auth.name')}</label>
                <input id="name" type="text" className="uh-login-input" value={name}
                  onChange={e => setName(e.target.value)} required disabled={loading} />
              </div>
              <div className="uh-login-field">
                <label htmlFor="email" className="uh-login-label">{t('auth.email')}</label>
                <input id="email" type="email" className="uh-login-input" value={email}
                  onChange={e => setEmail(e.target.value)} required disabled={loading} />
              </div>
              <div className="uh-login-field">
                <label htmlFor="password" className="uh-login-label">{t('auth.passwordMin')}</label>
                <input id="password" type="password" className="uh-login-input" value={password}
                  onChange={e => setPassword(e.target.value)} required minLength={8} disabled={loading} />
              </div>
              <div className="uh-login-buttons">
                <button type="submit" className="uh-btn uh-btn-primary" disabled={loading}>
                  {loading ? t('auth.creatingAccount') : t('auth.createAccount')}
                </button>
              </div>
            </form>
            <div className="uh-login-alt">
              {t('auth.alreadyHaveAccount')} <Link to="/login">{t('auth.signInLink')}</Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RegisterPage;
